import React from 'react';

const withContentWrapper = <T extends {}>(
  WrappedComponent: React.ComponentType<T>
) => {
  const HOC: React.FC<T> = (props) => (
    <div css="margin: 24px">
      <WrappedComponent {...props} />
    </div>
  );

  return HOC;
};

export default withContentWrapper;
